export const jsonParseData = (value: any, defaultValue: any) => {
  if (!value || typeof value !== 'string') {
    // console.warn('JSON.parse need string param');
    return defaultValue;
  }
  try {
    return JSON.parse(value);
  } catch (e) {
    return defaultValue;
  }
};

export const mergeObjects = (...objects: any) => {
  const merged: any = {};
  // 合并所有对象的键值对
  objects.forEach((obj: any) => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined) {
        // 如果键不存在或者值为 undefined，则将值赋给合并后的对象
        if (!merged.hasOwnProperty(key) || merged[key] === undefined) {
          merged[key] = obj[key];
        }
      }
    }
  });

  return merged;
}

